import React from 'react';
import BarometreForm from 'containers/BarometreForm';
import StepsForm from 'containers/StepsForm';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import { BAROMETRE_URL, ESTIMA_BASE_URL } from 'constants/Global';

import NotFoundPage from './components/NotFoundPage';
import history from './History';

/**
 * Build the router
 * @param {Object} history History object from react-router-redux
 * @returns {XML}
 */
const Routing = (props) => (
    <Router history={history}>
        <Switch>
            <Redirect exact path="/" to={`${ESTIMA_BASE_URL}/form`} />
            <Route
                exact
                path={`${ESTIMA_BASE_URL}/form`}
                render={() => React.cloneElement(<StepsForm />, props)}
            />
            <Route
                exact
                path={`${ESTIMA_BASE_URL}${BAROMETRE_URL}`}
                render={() => React.cloneElement(<BarometreForm />, props)}
            />
            <Route component={NotFoundPage} />
        </Switch>
    </Router>
);

Routing.displayName = 'Routing';

export default Routing;
